import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { appData } from 'Settings';

import Button from 'Components/Button';
import Toggle from 'Components/Toggle';
import Loading from 'Components/Loading';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import SectionHeader from 'Components/SectionHeader';
import styles from './EditEnabledModulesForm.scss';

function EditEnabledModulesForm(props) {
  const { onSubmit } = props;
  const [disabledModules, setDisabledModules] = useState(props.disabledModules);

  if (!disabledModules) {
    return <Loading />;
  }

  return (
    <div className="EditEnabledModulesForm">
      <div className="Lightbox__header-container">
        <div>
          <SectionHeader
            title={
              <ConnectedFormattedMessage id="edit_enabled_modules_form.title" />
            }
            description={
              <div>
                <p
                  className="SectionHeader__description"
                  style={{ marginBottom: 0 }}
                >
                  <ConnectedFormattedMessage id="edit_enabled_modules_form.description" />
                </p>
              </div>
            }
          />
        </div>
      </div>
      <div>
        {appData.map(({ slug, title, thumbnailImg }) => {
          const onChange = () => {
            const newDisabledModules = disabledModules.slice();
            const index = disabledModules.indexOf(slug);
            if (index > -1) {
              newDisabledModules.splice(index, 1);
            } else if (
              /* Must have one checked */
              newDisabledModules.length <
              Object.keys(appData).length - 1
            ) {
              newDisabledModules.push(slug);
            }
            setDisabledModules(newDisabledModules);
          };

          return (
            <div className="EditEnabledModulesForm__ListElement">
              <ConnectedFormattedImage
                className="EditEnabledModulesForm__ListElement__Thumbnail"
                src={thumbnailImg}
                altId={`model.${slug}.graphicAlt`}
              />
              <h4>{title}</h4>
              <Toggle
                checked={!disabledModules.includes(slug)}
                onChange={onChange}
              />
            </div>
          );
        })}
      </div>
      <div className="EditEnabledModulesForm__ButtonWrapper">
        <Button
          buttonType="primary"
          label={
            <ConnectedFormattedMessage id="edit_enabled_modules_form.save_changes" />
          }
          clickHandler={() => {
            onSubmit(disabledModules);
          }}
        />
      </div>
    </div>
  );
}

EditEnabledModulesForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabledModules: PropTypes.array.isRequired,
};

export default EditEnabledModulesForm;
